module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley"
  }, [_c('div', {
    staticClass: "frontmatter TableOfContents"
  }, [_c('p', {
    attrs: {
      "id": "rw-p_110259-00001"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_xv"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_xv"
    }
  }, [_c('div', {
    staticClass: "title-block",
    attrs: {
      "id": "rw-title-block_110259-00001"
    }
  }, [_c('h1', [_vm._v("Contents")])])]), _c('div', {
    staticClass: "block toc",
    attrs: {
      "id": "rw-block-toc_110259-00001"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_xv"
    }
  }), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_xv"
    }
  }, [_c('span', {
    staticClass: "sc"
  })]), _c('a', {
    attrs: {
      "href": "#/9781847674951_chapter_01"
    }
  }, [_vm._v("ABBREVIATIONS USED BY SCOTT")])]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110259-00001"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp"
  }, [_c('span', {
    staticClass: "sc"
  }, [_c('a', {
    attrs: {
      "href": "#/9781847674951_chapter_02"
    }
  }, [_vm._v("ABBREVIATIONS USED IN THE NOTES")])])]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110259-00002"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp"
  }, [_c('span', {
    staticClass: "sc"
  }, [_c('a', {
    attrs: {
      "href": "#/9781847674951_introduction"
    }
  }, [_vm._v("INTRODUCTION")])])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#/9781847674951_introduction#rw-h2_110262-00001"
    }
  }, [_vm._v("Scott’s Edinburgh: The Changing City")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#/9781847674951_introduction#rw-h2_110262-00002"
    }
  }, [_vm._v("The Law")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#/9781847674951_introduction#rw-h2_110262-00003"
    }
  }, [_vm._v("Abbotsford")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#/9781847674951_introduction#rw-h2_110262-00004"
    }
  }, [_vm._v("The Financial Crash")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#/9781847674951_introduction#rw-h2_110262-00005"
    }
  }, [_vm._v("The Arbitration")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#/9781847674951_introduction#rw-h2_110262-00006"
    }
  }, [_vm._v("Political Affairs")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#/9781847674951_introduction#rw-h2_110262-00007"
    }
  }, [_vm._v("The People of the "), _c('i', [_vm._v("Journal")])])]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110259-00003"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp"
  }, [_c('span', {
    staticClass: "sc"
  }, [_c('a', {
    attrs: {
      "href": "#/9781847674951_chapter_03"
    }
  }, [_vm._v("THE EVENTS OF THE "), _c('i', [_vm._v("JOURNAL")])])])]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110259-00004"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp"
  }, [_c('a', {
    attrs: {
      "href": "#/9781847674951_part_01"
    }
  }, [_vm._v("THE JOURNAL")])]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110259-00005"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp"
  }, [_c('span', {
    staticClass: "sc"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ADDITIONAL NOTES")])])]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110259-00006"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp"
  }, [_c('span', {
    staticClass: "sc"
  }, [_vm._v("APPENDICES")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/9781847674951_appendix",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sc"
  }, [_vm._v("A")]), _vm._v(". Chronology of the Life of Sir Walter Scott")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/9781847674951_appendix_02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sc"
  }, [_vm._v("B")]), _vm._v(". Country Houses of the "), _c('i', [_vm._v("Journal")]), _vm._v(" and their Owners")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/9781847674951_appendix_03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sc"
  }, [_vm._v("C")]), _vm._v(". Edinburgh Addresses")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/9781847674951_appendix_04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sc"
  }, [_vm._v("D")]), _vm._v(". Politics in the "), _c('i', [_vm._v("Journal")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/9781847674951_appendix_05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sc"
  }, [_vm._v("E")]), _vm._v(". Dating")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/9781847674951_appendix_06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sc"
  }, [_vm._v("F")]), _vm._v(". Silent Corrections")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/9781847674951_appendix_07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sc"
  }, [_vm._v("G")]), _vm._v(". Memoranda")])]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110259-00007"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp"
  }, [_c('span', {
    staticClass: "sc"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("INDEX")])])])]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110259-00002"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_xvi"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_xvi"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_xvi"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_xvi"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-777f2164","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781847674951_tableofcontents.vue
// module id = 69
// module chunks = 0